/* ==========================================================================
   LIQUID_GOLD: Kino Mojo $99 PDP — window.LiquidGold.MojoPDP
   Loaded deferred by sections/liquid_gold_mojo_buybox.liquid. No dependencies.
   Each module initialises from its data-lg-* root and guards against re-init
   so shopify:section:load can call init() again safely.
   ========================================================================== */
(function () {
  'use strict';

  window.LiquidGold = window.LiquidGold || {};
  var LG = window.LiquidGold;

  var DESKTOP_MQ = '(min-width: 48em)';
  var MOBILE_MQ = '(max-width: 47.99em)';
  var PROMO_KEY = 'three_month';
  var ONE_TIME_KEY = 'one_time';

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function once(el, key) {
    var flag = 'lgInit' + key;
    if (!el || el.dataset[flag]) return false;
    el.dataset[flag] = '1';
    return true;
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function emit(name, detail, target) {
    (target || document).dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
  }

  /* ------------------------------------------------------------------------
     Plans: one shared selection across hero / final offer / sticky ATC
     ------------------------------------------------------------------------ */
  var Plans = {
    state: {
      index: null,
      key: null,
      variantId: null,
      sellingPlanId: null,
      quantity: 1,
      isSubscription: false,
      available: true
    },

    selectors: function () {
      return toArray(document.querySelectorAll('[data-lg-plan-selector]'));
    },

    init: function (root) {
      var self = this;

      toArray(root.querySelectorAll('[data-lg-plan-selector][data-lg-clone-from]')).forEach(function (shell) {
        self.hydrateShell(shell);
      });

      toArray(root.querySelectorAll('[data-lg-plan-selector]')).forEach(function (selector) {
        if (!once(selector, 'Plans')) return;

        selector.addEventListener('change', function (event) {
          var radio = event.target.closest('[data-lg-plan-radio]');
          if (radio) self.select(Number(radio.value));
        });

        selector.addEventListener('click', function (event) {
          var link = event.target.closest('[data-lg-one-time-link]');
          if (!link) return;
          var oneTime = selector.querySelector('[data-lg-plan][data-lg-plan-key="' + ONE_TIME_KEY + '"]');
          if (oneTime) self.select(Number(oneTime.dataset.lgPlanIndex));
        });
      });

      if (once(document.body, 'PlansDelegate')) {
        document.addEventListener('click', function (event) {
          var trigger = event.target.closest('[data-lg-select-plan]');
          if (!trigger) return;
          event.preventDefault();
          self.selectByKey(trigger.dataset.lgSelectPlan);
        });
      }

      if (this.state.index === null) {
        var hero = document.querySelector('[data-lg-plan-selector="hero"]');
        var preselected = hero && hero.querySelector('[data-lg-plan][data-lg-selected]');
        if (preselected) this.select(Number(preselected.dataset.lgPlanIndex));
      } else {
        this.apply();
      }
    },

    // Secondary selectors render an empty shell; the hero's cards are cloned into it.
    hydrateShell: function (shell) {
      if (shell.dataset.lgHydrated) return;
      var hero = document.querySelector('[data-lg-plan-selector="hero"]');
      if (!hero) return;

      var name = 'lg-plan-' + shell.dataset.lgPlanSelector + '-' + (shell.dataset.lgSectionId || Math.random().toString(36).slice(2));
      var anchor = shell.querySelector('[data-lg-input-id]');
      var compact = shell.dataset.lgCompact === 'true';

      toArray(hero.querySelectorAll(':scope > [data-lg-plan], :scope > [data-lg-one-time-link]')).forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.removeAttribute('data-shopify-editor-block');
        if (compact) {
          toArray(clone.querySelectorAll('[data-lg-plan-extra]')).forEach(function (extra) {
            extra.remove();
          });
        }
        toArray(clone.querySelectorAll('[data-lg-plan-radio]')).forEach(function (radio) {
          radio.name = name;
        });
        shell.insertBefore(clone, anchor);
      });

      shell.dataset.lgHydrated = '1';
    },

    findCard: function (index) {
      return document.querySelector('[data-lg-plan-selector="hero"] [data-lg-plan][data-lg-plan-index="' + index + '"]') ||
        document.querySelector('[data-lg-plan][data-lg-plan-index="' + index + '"]');
    },

    select: function (index) {
      var card = this.findCard(index);
      if (!card) return;

      this.state = {
        index: index,
        key: card.dataset.lgPlanKey || '',
        variantId: card.dataset.lgVariantId || null,
        sellingPlanId: card.dataset.lgSellingPlanId || null,
        quantity: parseInt(card.dataset.lgQuantity, 10) || 1,
        isSubscription: card.dataset.lgSubscription === 'true',
        available: card.dataset.lgUnavailable !== 'true'
      };

      this.apply();
      emit('liquid-gold:plan-change', {
        index: this.state.index,
        variantId: this.state.variantId,
        sellingPlanId: this.state.sellingPlanId,
        quantity: this.state.quantity,
        isSubscription: this.state.isSubscription,
        planKey: this.state.key
      });
    },

    selectByKey: function (key) {
      var card = document.querySelector('[data-lg-plan-selector="hero"] [data-lg-plan][data-lg-plan-key="' + key + '"]') ||
        document.querySelector('[data-lg-plan][data-lg-plan-key="' + key + '"]');
      if (card) this.select(Number(card.dataset.lgPlanIndex));
    },

    giftMode: function () {
      if (!this.state.isSubscription) return ONE_TIME_KEY;
      return this.state.key === PROMO_KEY ? PROMO_KEY : 'one_month';
    },

    apply: function () {
      var s = this.state;
      if (s.index === null) return;

      this.selectors().forEach(function (selector) {
        selector.dataset.lgSelectedKey = s.key;
        toArray(selector.querySelectorAll('[data-lg-plan]')).forEach(function (card) {
          var on = Number(card.dataset.lgPlanIndex) === s.index;
          if (on) card.setAttribute('data-lg-selected', '');
          else card.removeAttribute('data-lg-selected');
          var radio = card.querySelector('[data-lg-plan-radio]');
          if (radio) radio.checked = on;
        });
      });

      toArray(document.querySelectorAll('[data-lg-product-form]')).forEach(function (form) {
        var idInput = form.querySelector('[data-lg-input-id]');
        var qtyInput = form.querySelector('[data-lg-input-quantity]');
        var planInput = form.querySelector('[data-lg-input-selling-plan]');
        if (idInput && s.variantId) idInput.value = s.variantId;
        if (qtyInput) qtyInput.value = s.quantity;
        if (planInput) {
          if (s.isSubscription && s.sellingPlanId) {
            planInput.value = s.sellingPlanId;
            planInput.disabled = false;
          } else {
            planInput.value = '';
            planInput.disabled = true;
          }
        }
        var submit = form.querySelector('[type="submit"]');
        if (submit) submit.disabled = !s.available;
      });

      toArray(document.querySelectorAll('[data-lg-cta-label]')).forEach(function (label) {
        var promo = label.dataset.lgLabelPromo;
        var fallback = label.dataset.lgLabelDefault || label.textContent;
        var soldOut = label.dataset.lgLabelSoldOut;
        if (!s.available && soldOut) label.textContent = soldOut;
        else label.textContent = (s.key === PROMO_KEY && promo) ? promo : fallback;
      });

      var mode = this.giftMode();
      toArray(document.querySelectorAll('[data-lg-gift-strip]')).forEach(function (strip) {
        strip.dataset.lgMode = mode;
      });

      // Decorative refill pills and the sticky bar label follow the selection
      toArray(document.querySelectorAll('[data-lg-refill-pill]')).forEach(function (pill) {
        var on = s.isSubscription && pill.dataset.lgRefillPill === (s.key === PROMO_KEY ? PROMO_KEY : 'one_month');
        if (on) pill.setAttribute('data-lg-active', '');
        else pill.removeAttribute('data-lg-active');
      });

      var card = this.findCard(s.index);
      var label = card && card.dataset.lgPlanLabel;
      if (label) {
        toArray(document.querySelectorAll('[data-lg-sticky-label]')).forEach(function (el) {
          el.textContent = label;
        });
      }
    }
  };

  /* ------------------------------------------------------------------------
     Cart: AJAX add + native drawer trigger
     ------------------------------------------------------------------------ */
  var Cart = {
    // Capture-phase listeners so theme or app scripts that hook product forms
    // (and would post natively or redirect) never see the submit.
    init: function () {
      if (!once(document.body, 'Cart')) return;
      var self = this;

      document.addEventListener('click', function (event) {
        var button = event.target.closest('[data-lg-product-form] [type="submit"]');
        if (!button) return;
        var form = button.closest('[data-lg-product-form]');
        if (!self.canHandle(form)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        self.submit(form);
      }, true);

      document.addEventListener('submit', function (event) {
        var form = event.target.closest && event.target.closest('[data-lg-product-form]');
        if (!form || !self.canHandle(form)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        self.submit(form);
      }, true);
    },

    canHandle: function (form) {
      var routes = LG.routes || {};
      return !!(form && routes.cartAdd && window.fetch && this.selection(form).variantId);
    },

    // Plan state first, then the form's own hidden inputs as the fallback
    selection: function (form) {
      var s = Plans.state;
      if (s.variantId) return s;
      var idInput = form.querySelector('[data-lg-input-id]');
      var qtyInput = form.querySelector('[data-lg-input-quantity]');
      var planInput = form.querySelector('[data-lg-input-selling-plan]');
      var sellingPlanId = planInput && !planInput.disabled ? planInput.value : null;
      return {
        variantId: idInput && idInput.value,
        quantity: (qtyInput && parseInt(qtyInput.value, 10)) || 1,
        sellingPlanId: sellingPlanId || null,
        isSubscription: !!sellingPlanId,
        available: true
      };
    },

    buildItems: function (form) {
      var s = this.selection(form);
      var item = { id: Number(s.variantId), quantity: s.quantity || 1 };
      if (s.isSubscription && s.sellingPlanId) item.selling_plan = Number(s.sellingPlanId);
      var items = [item];

      // Optional: mirror the theme form's compound free-gift line items.
      if (s.isSubscription && form.dataset.lgGiftVariants) {
        try {
          var giftIds = JSON.parse(form.dataset.lgGiftVariants);
          if (Array.isArray(giftIds) && giftIds.length) {
            var compoundId = item.id + ':' + Date.now().toString(36);
            item.properties = {
              _is_free_gift_parent_compound: true,
              _free_gift_compound_id: compoundId
            };
            giftIds.forEach(function (id) {
              items.push({
                id: Number(id),
                quantity: 1,
                properties: {
                  'Free Gift': 'Offer',
                  _is_free_gift: true,
                  _is_free_gift_compound: true,
                  _free_gift_compound_id: compoundId
                }
              });
            });
          }
        } catch (err) {
          /* malformed attribute: ignore gifts */
        }
      }
      return items;
    },

    setBusy: function (form, busy) {
      var button = form.querySelector('[type="submit"]');
      if (!button) return;
      var label = button.querySelector('[data-lg-cta-label]');
      if (busy) {
        button.setAttribute('data-lg-busy', '');
        button.setAttribute('aria-busy', 'true');
        if (label) {
          label.dataset.lgRestore = label.textContent;
          if (form.dataset.lgLabelBusy) label.textContent = form.dataset.lgLabelBusy;
        }
      } else {
        button.removeAttribute('data-lg-busy');
        button.removeAttribute('aria-busy');
        if (label && label.dataset.lgRestore) {
          label.textContent = label.dataset.lgRestore;
          delete label.dataset.lgRestore;
        }
      }
    },

    showError: function (form, message) {
      var box = form.querySelector('[data-lg-form-error]');
      if (!box) return;
      box.textContent = message || form.dataset.lgLabelError || '';
      box.setAttribute('data-lg-visible', '');
    },

    clearError: function (form) {
      var box = form.querySelector('[data-lg-form-error]');
      if (box) box.removeAttribute('data-lg-visible');
    },

    submit: function (form) {
      var routes = LG.routes || {};
      var s = this.selection(form);
      if (form.hasAttribute('data-lg-busy') || !s.available) return;

      var self = this;
      form.setAttribute('data-lg-busy', '');
      this.clearError(form);
      this.setBusy(form, true);

      fetch(routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: this.buildItems(form) })
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok) {
              throw new Error(data.description || data.message || form.dataset.lgLabelError || 'Error');
            }
            return data;
          });
        })
        .then(function (data) {
          form.removeAttribute('data-lg-busy');
          self.setBusy(form, false);
          emit('liquid-gold:cart-added', { items: data.items || [], form: form }, form);
          self.afterAdd(form);
        })
        .catch(function (err) {
          form.removeAttribute('data-lg-busy');
          self.setBusy(form, false);
          self.showError(form, err && err.message);
        });
    },

    // Cart UI, in order: Rebuy Smart Cart, the theme's offcanvas drawer, an
    // inline confirmation. Only the "cart" setting leaves the page.
    afterAdd: function (form) {
      var routes = LG.routes || {};
      var heroForm = document.querySelector('[data-lg-product-form="hero"]');
      var mode = form.dataset.lgAfterAdd || (heroForm && heroForm.dataset.lgAfterAdd) || 'drawer';

      if (mode === 'cart') {
        if (routes.cartUrl) window.location.href = routes.cartUrl;
        return;
      }

      var rebuy = window.Rebuy;
      if (rebuy && rebuy.SmartCart && typeof rebuy.SmartCart.show === 'function') {
        try {
          if (rebuy.Cart && typeof rebuy.Cart.refresh === 'function') rebuy.Cart.refresh();
          rebuy.SmartCart.show();
          return;
        } catch (err) { /* fall through */ }
      }

      var drawer = document.querySelector('.js-offcanvas[data-drawer-names~="cart"]');
      var trigger = document.querySelector('[data-lg-cart-trigger]');
      if (drawer && trigger) {
        trigger.click();
        return;
      }

      this.showAdded(form);
    },

    showAdded: function (form) {
      var button = form.querySelector('[type="submit"]');
      var label = button && button.querySelector('[data-lg-cta-label]');
      var text = form.dataset.lgLabelAdded;
      if (!label || !text) return;
      var restore = label.textContent;
      label.textContent = text;
      button.setAttribute('data-lg-added', '');
      setTimeout(function () {
        label.textContent = restore;
        button.removeAttribute('data-lg-added');
      }, 2200);
    }
  };

  /* ------------------------------------------------------------------------
     Gallery: thumbs, snap track, desktop drag, mobile dots, video visibility
     ------------------------------------------------------------------------ */
  var Gallery = {
    init: function (root) {
      var self = this;
      toArray(root.querySelectorAll('[data-lg-gallery]')).forEach(function (gallery) {
        if (once(gallery, 'Gallery')) self.setup(gallery);
      });
    },

    setup: function (gallery) {
      var track = gallery.querySelector('[data-lg-gallery-track]');
      if (!track) return;
      var slides = toArray(track.children);
      var thumbs = toArray(gallery.querySelectorAll('[data-lg-gallery-thumb]'));
      var current = 0;
      var raf = 0;

      function setActive(index) {
        current = clamp(index, 0, slides.length - 1);
        thumbs.forEach(function (thumb, i) {
          thumb.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
        var activeThumb = thumbs[current];
        if (activeThumb && activeThumb.scrollIntoView) {
          activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }

      function goTo(index, smooth) {
        var target = slides[clamp(index, 0, slides.length - 1)];
        if (!target) return;
        track.scrollTo({
          left: target.offsetLeft,
          behavior: smooth !== false && !reducedMotion() ? 'smooth' : 'auto'
        });
        setActive(index);
      }

      function nearestIndex() {
        var left = track.scrollLeft;
        var best = 0;
        var bestDistance = Infinity;
        slides.forEach(function (slide, i) {
          var distance = Math.abs(slide.offsetLeft - left);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        });
        return best;
      }

      gallery.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-lg-gallery-thumb]');
        if (thumb) return goTo(Number(thumb.dataset.lgGalleryThumb));
        if (event.target.closest('[data-lg-gallery-prev]')) return goTo(current - 1);
        if (event.target.closest('[data-lg-gallery-next]')) return goTo(current + 1);
      });

      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1); }
      });

      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          if (track.hasAttribute('data-lg-dragging')) return;
          var index = nearestIndex();
          if (index !== current) setActive(index);
        });
      }, { passive: true });

      // Desktop drag-to-swipe; mobile keeps native scroll-snap.
      var drag = null;
      track.addEventListener('pointerdown', function (event) {
        if (!isDesktop() || event.button !== 0) return;
        drag = { x: event.clientX, left: track.scrollLeft, moved: false, id: event.pointerId };
        track.setPointerCapture(event.pointerId);
      });
      track.addEventListener('pointermove', function (event) {
        if (!drag) return;
        var delta = event.clientX - drag.x;
        if (!drag.moved && Math.abs(delta) > 4) {
          drag.moved = true;
          track.setAttribute('data-lg-dragging', '');
        }
        if (drag.moved) track.scrollLeft = drag.left - delta;
      });
      function endDrag(event) {
        if (!drag) return;
        var moved = drag.moved;
        var delta = event.clientX - drag.x;
        drag = null;
        track.removeAttribute('data-lg-dragging');
        if (moved) {
          var index = current;
          if (delta < -40) index = current + 1;
          else if (delta > 40) index = current - 1;
          else index = nearestIndex();
          goTo(index);
        }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', function (event) {
        if (event.target.closest('a') && track.hasAttribute('data-lg-dragging')) event.preventDefault();
      });

      // Videos: play only while visible
      var videos = toArray(track.querySelectorAll('video'));
      if (videos.length && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && !reducedMotion()) {
              var playing = video.play();
              if (playing && playing.catch) playing.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.4 });
        videos.forEach(function (video) { io.observe(video); });
      }

      var mq = window.matchMedia(DESKTOP_MQ);
      mq.addEventListener('change', function () { goTo(current, false); });

      setActive(0);
    }
  };

  /* ------------------------------------------------------------------------
     AutoRail: rAF auto-scroll with seamless loop and hold-on-touch
     ------------------------------------------------------------------------ */
  var AutoRail = {
    init: function (root) {
      var self = this;
      toArray(root.querySelectorAll('[data-lg-autorail]')).forEach(function (rail) {
        if (once(rail, 'AutoRail')) self.setup(rail);
      });
    },

    setup: function (rail) {
      var speed = parseFloat(rail.dataset.lgAutorailSpeed) || 0.22;
      var hold = parseInt(rail.dataset.lgAutorailHold, 10) || 2500;
      var mq = window.matchMedia(rail.dataset.lgAutorailMedia || MOBILE_MQ);
      var originals = toArray(rail.children);
      var clones = [];
      var active = false;
      var raf = 0;
      var pausedUntil = 0;
      var pos = 0;

      function tick() {
        if (!active) return;
        var now = performance.now();
        if (now > pausedUntil && !document.hidden) {
          var half = rail.scrollWidth / 2;
          if (half > 0) {
            pos += speed;
            if (pos >= half) pos -= half;
            rail.scrollLeft = pos;
          }
        }
        raf = requestAnimationFrame(tick);
      }

      function pause() {
        pausedUntil = performance.now() + hold;
      }

      function start() {
        if (active || reducedMotion() || originals.length < 2) return;
        active = true;
        clones = originals.map(function (node) {
          var clone = node.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          rail.appendChild(clone);
          return clone;
        });
        rail.setAttribute('data-lg-autorail-on', '');
        pos = rail.scrollLeft;
        raf = requestAnimationFrame(tick);
      }

      function stop() {
        if (!active) return;
        active = false;
        cancelAnimationFrame(raf);
        clones.forEach(function (clone) { clone.remove(); });
        clones = [];
        rail.removeAttribute('data-lg-autorail-on');
        rail.scrollLeft = 0;
      }

      ['touchstart', 'wheel', 'pointerdown'].forEach(function (type) {
        rail.addEventListener(type, pause, { passive: true });
      });

      if (rail.dataset.lgAutorailHover === 'true') {
        rail.addEventListener('mouseenter', function () { pausedUntil = Infinity; });
        rail.addEventListener('mouseleave', function () { pausedUntil = 0; });
      }

      // Re-sync after manual scrolling so the loop stays seamless.
      rail.addEventListener('scroll', function () {
        if (!active) return;
        if (Math.abs(rail.scrollLeft - pos) > 1) pos = rail.scrollLeft;
        var half = rail.scrollWidth / 2;
        if (pos >= half) {
          pos -= half;
          rail.scrollLeft = pos;
        }
      }, { passive: true });

      function update() {
        if (mq.matches) start();
        else stop();
      }
      update();
      mq.addEventListener('change', update);
    }
  };

  /* ------------------------------------------------------------------------
     Reveal: [data-lg-reveal] fade-up on first view
     ------------------------------------------------------------------------ */
  var Reveal = {
    observer: null,

    init: function (root) {
      var disabled = reducedMotion() || !!document.querySelector('[data-lg-reveal-motion="false"]');
      var targets = toArray(root.querySelectorAll('[data-lg-reveal]:not([data-lg-on])'));
      if (root !== document && root.matches && root.matches('[data-lg-reveal]:not([data-lg-on])')) targets.push(root);

      if (disabled || !('IntersectionObserver' in window)) {
        targets.forEach(function (el) { el.dataset.lgOn = '1'; });
        return;
      }

      if (!this.observer) {
        var self = this;
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.dataset.lgOn = '1';
            self.observer.unobserve(entry.target);
          });
        }, { threshold: 0.12 });
      }
      targets.forEach(function (el) { Reveal.observer.observe(el); });
    }
  };

  /* ------------------------------------------------------------------------
     Delivery: today + N business days (skips weekends), cutoff-aware
     ------------------------------------------------------------------------ */
  var Delivery = {
    init: function (root) {
      var self = this;
      toArray(root.querySelectorAll('[data-lg-delivery-date]')).forEach(function (el) {
        if (!once(el, 'Delivery')) return;
        var date = self.compute(
          parseInt(el.dataset.lgDays, 10) || 5,
          parseInt(el.dataset.lgCutoffHour, 10) || 15,
          el.dataset.lgTimezone || 'America/New_York'
        );
        el.textContent = self.format(date, el.dataset.lgLocale || document.documentElement.lang || 'en-US');
        el.setAttribute('datetime', date.toISOString().slice(0, 10));
      });
    },

    compute: function (days, cutoffHour, timeZone) {
      var now = new Date();
      var hour = now.getHours();
      try {
        hour = parseInt(new Intl.DateTimeFormat('en-US', { hour: 'numeric', hourCycle: 'h23', timeZone: timeZone }).format(now), 10);
      } catch (err) { /* fall back to local hour */ }
      var date = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      if (hour >= cutoffHour) date.setDate(date.getDate() + 1);
      var added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        var day = date.getDay();
        if (day !== 0 && day !== 6) added += 1;
      }
      return date;
    },

    format: function (date, locale) {
      try {
        return new Intl.DateTimeFormat(locale, { weekday: 'short', month: 'short', day: 'numeric' }).format(date);
      } catch (err) {
        return date.toDateString();
      }
    }
  };

  /* ------------------------------------------------------------------------
     Anchors: smooth-scroll in-page links inside .lg-mojo (promo banner)
     ------------------------------------------------------------------------ */
  var Anchors = {
    init: function () {
      if (!once(document.body, 'Anchors')) return;
      document.addEventListener('click', function (event) {
        var link = event.target.closest('.lg-mojo a[href^="#"]');
        if (!link) return;
        var id = link.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: top, behavior: reducedMotion() ? 'auto' : 'smooth' });
      });
    }
  };

  /* ------------------------------------------------------------------------
     Videos: ambient videos play only while in view
     ------------------------------------------------------------------------ */
  var Videos = {
    observer: null,

    init: function (root) {
      var videos = toArray(root.querySelectorAll('[data-lg-video]')).filter(function (v) { return once(v, 'Video'); });
      if (!videos.length) return;
      if (!('IntersectionObserver' in window)) return;

      if (!this.observer) {
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && !reducedMotion()) {
              var playing = video.play();
              if (playing && playing.catch) playing.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.25 });
      }
      videos.forEach(function (video) { Videos.observer.observe(video); });
    }
  };

  /* ------------------------------------------------------------------------
     Timeline: flags [data-lg-timeline] / [data-lg-inview] once visible
     ------------------------------------------------------------------------ */
  var Timeline = {
    init: function (root) {
      var targets = toArray(root.querySelectorAll('[data-lg-timeline], [data-lg-inview]')).filter(function (el) {
        return once(el, 'Timeline');
      });
      if (!targets.length) return;

      if (reducedMotion() || !('IntersectionObserver' in window)) {
        targets.forEach(function (el) { el.dataset.lgOn = '1'; });
        return;
      }

      targets.forEach(function (el) {
        var threshold = parseFloat(el.dataset.lgInviewThreshold) || 0.2;
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            el.dataset.lgOn = '1';
            observer.disconnect();
          });
        }, { threshold: threshold });
        observer.observe(el);
      });
    }
  };

  /* ------------------------------------------------------------------------
     DoseBars: log-scaled bar widths + count-up on first view
     ------------------------------------------------------------------------ */
  var DoseBars = {
    MAX_LOG: Math.log10(400000),

    parse: function (text) {
      var match = /([\d.,]+)\s*([a-z]+)?/i.exec(text || '');
      if (!match) return null;
      var value = parseFloat(match[1].replace(/,/g, ''));
      if (isNaN(value)) return null;
      var unit = (match[2] || 'mg').toLowerCase();
      var mcg = value;
      if (unit === 'mg') mcg = value * 1000;
      else if (unit === 'g') mcg = value * 1000000;
      return {
        value: value,
        prefix: text.slice(0, match.index),
        suffix: text.slice(match.index + match[1].length),
        decimals: (match[1].split('.')[1] || '').length,
        mcg: mcg
      };
    },

    init: function (root) {
      var self = this;
      toArray(root.querySelectorAll('[data-lg-dose-bars]')).forEach(function (card) {
        if (once(card, 'DoseBars')) self.setup(card);
      });
    },

    setup: function (card) {
      var self = this;
      var rows = toArray(card.querySelectorAll('[data-lg-dose]')).map(function (row) {
        var parsed = self.parse(row.dataset.lgDose);
        if (parsed) {
          var ratio = clamp(Math.log10(Math.max(parsed.mcg, 1)) / self.MAX_LOG, 0.04, 1);
          row.style.setProperty('--lg-bar', ratio.toFixed(3));
        }
        return { el: row, parsed: parsed, value: row.querySelector('[data-lg-dose-value]') };
      });

      var animate = card.dataset.lgAnimate !== 'false' && !reducedMotion() && 'IntersectionObserver' in window;
      if (!animate) {
        card.dataset.lgOn = '1';
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          card.dataset.lgOn = '1';
          rows.forEach(function (row, i) {
            if (row.parsed && row.value) self.countUp(row, i * 70);
          });
        });
      }, { threshold: 0.35 });
      observer.observe(card);
    },

    countUp: function (row, delay) {
      var parsed = row.parsed;
      var target = row.value;
      var duration = 1600;
      var start = null;
      var hidden = target.querySelector('.lg-visually-hidden');
      var hiddenText = hidden ? hidden.outerHTML : '';

      function render(value) {
        target.innerHTML = hiddenText + parsed.prefix + value.toFixed(parsed.decimals) + parsed.suffix;
      }

      function frame(now) {
        if (start === null) start = now;
        var t = clamp((now - start) / duration, 0, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        render(parsed.value * eased);
        if (t < 1) requestAnimationFrame(frame);
      }

      render(0);
      setTimeout(function () { requestAnimationFrame(frame); }, delay);
    }
  };

  /* ------------------------------------------------------------------------
     Accordion: native <details>; mobile keeps only the first row open
     ------------------------------------------------------------------------ */
  var Accordion = {
    init: function (root) {
      toArray(root.querySelectorAll('[data-lg-accordion]')).forEach(function (group) {
        if (!once(group, 'Accordion')) return;
        if (isDesktop()) return;
        toArray(group.querySelectorAll('details')).forEach(function (item, i) {
          if (i > 0) item.open = false;
        });
      });
    }
  };

  /* ------------------------------------------------------------------------
     ProofSlider: crossfade slides driven by the CSS progress animation
     ------------------------------------------------------------------------ */
  var ProofSlider = {
    init: function (root) {
      var self = this;
      toArray(root.querySelectorAll('[data-lg-proof-slider]')).forEach(function (slider) {
        if (once(slider, 'ProofSlider')) self.setup(slider);
      });
    },

    setup: function (slider) {
      var slides = toArray(slider.querySelectorAll('[data-lg-proof-slide]'));
      var bars = toArray(slider.querySelectorAll('[data-lg-proof-bar]'));
      var current = 0;
      if (slides.length < 2) return;

      function goTo(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          if (i === current) {
            slide.setAttribute('data-lg-active', '');
            slide.setAttribute('aria-hidden', 'false');
          } else {
            slide.removeAttribute('data-lg-active');
            slide.setAttribute('aria-hidden', 'true');
          }
        });
        bars.forEach(function (bar, i) {
          bar.setAttribute('aria-current', i === current ? 'true' : 'false');
          var state = i < current ? 'done' : (i === current ? 'active' : 'idle');
          if (state === 'active') {
            // Restart the fill animation even when re-selecting the same bar
            bar.dataset.lgState = 'idle';
            void bar.offsetWidth;
          }
          bar.dataset.lgState = state;
        });
      }

      slider.addEventListener('click', function (event) {
        var bar = event.target.closest('[data-lg-proof-bar]');
        if (bar) goTo(Number(bar.dataset.lgProofBar));
      });

      slider.addEventListener('animationend', function (event) {
        if (event.animationName !== 'lg-proof-fill') return;
        goTo(current + 1);
      });

      slider.addEventListener('keydown', function (event) {
        if (!event.target.closest('[data-lg-proof-bar]')) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1); }
      });
    }
  };

  /* ------------------------------------------------------------------------
     CompareScrub: custom scrollbar for the comparison grid on mobile
     ------------------------------------------------------------------------ */
  var CompareScrub = {
    init: function (root) {
      var self = this;
      toArray(root.querySelectorAll('[data-lg-compare]')).forEach(function (scroll) {
        if (once(scroll, 'CompareScrub')) self.setup(scroll);
      });
    },

    setup: function (scroll) {
      var section = scroll.closest('.lg-compare') || scroll.parentElement;
      var scrub = section && section.querySelector('[data-lg-compare-scrub]');
      var track = scrub && scrub.querySelector('[data-lg-compare-track]');
      var thumb = scrub && scrub.querySelector('[data-lg-compare-thumb]');
      if (!scrub || !track || !thumb) return;

      function maxScroll() {
        return scroll.scrollWidth - scroll.clientWidth;
      }

      function range() {
        return track.clientWidth - thumb.offsetWidth;
      }

      function update() {
        var max = maxScroll();
        if (max <= 1 || isDesktop()) {
          scrub.hidden = true;
          return;
        }
        scrub.hidden = false;
        thumb.style.setProperty('--lg-scrub-x', (scroll.scrollLeft / max) * range() + 'px');
      }

      scroll.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      var drag = null;
      thumb.addEventListener('pointerdown', function (event) {
        drag = { x: event.clientX, left: scroll.scrollLeft };
        thumb.setPointerCapture(event.pointerId);
        event.preventDefault();
      });
      thumb.addEventListener('pointermove', function (event) {
        if (!drag || range() <= 0) return;
        scroll.scrollLeft = drag.left + (event.clientX - drag.x) * (maxScroll() / range());
      });
      function endDrag() { drag = null; }
      thumb.addEventListener('pointerup', endDrag);
      thumb.addEventListener('pointercancel', endDrag);

      thumb.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); scroll.scrollBy({ left: 80, behavior: 'smooth' }); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); scroll.scrollBy({ left: -80, behavior: 'smooth' }); }
      });

      track.addEventListener('click', function (event) {
        if (thumb.contains(event.target) || range() <= 0) return;
        var rect = track.getBoundingClientRect();
        var x = clamp(event.clientX - rect.left - thumb.offsetWidth / 2, 0, range());
        scroll.scrollTo({ left: (x / range()) * maxScroll(), behavior: reducedMotion() ? 'auto' : 'smooth' });
      });
    }
  };

  /* ------------------------------------------------------------------------
     FaqDrawer: side tab near the page end, dialog drawer with focus trap
     ------------------------------------------------------------------------ */
  var FaqDrawer = {
    init: function (root) {
      var self = this;
      toArray(root.querySelectorAll('[data-lg-faq]')).forEach(function (faq) {
        if (once(faq, 'FaqDrawer')) self.setup(faq);
      });
    },

    setup: function (faq) {
      var tab = faq.querySelector('[data-lg-faq-tab]');
      var drawer = faq.querySelector('[data-lg-faq-drawer]');
      var scrim = faq.querySelector('[data-lg-faq-scrim]');
      var closeButton = faq.querySelector('[data-lg-faq-close]');
      var list = faq.querySelector('[data-lg-faq-list]');
      if (!tab || !drawer) return;

      var offset = parseFloat(faq.dataset.lgRevealOffset) || 1.5;
      var isOpen = false;
      var lastFocus = null;
      var raf = 0;

      function updateTab() {
        var remaining = document.documentElement.scrollHeight - (window.pageYOffset + window.innerHeight);
        if (remaining <= offset * window.innerHeight) tab.setAttribute('data-lg-visible', '');
        else tab.removeAttribute('data-lg-visible');
      }

      function queueUpdate() {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(updateTab);
      }

      window.addEventListener('scroll', queueUpdate, { passive: true });
      window.addEventListener('resize', queueUpdate);
      if ('ResizeObserver' in window) new ResizeObserver(queueUpdate).observe(document.body);
      updateTab();

      function focusable() {
        return toArray(drawer.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'))
          .filter(function (el) { return el === closeButton || el.offsetParent !== null; });
      }

      function onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }
        if (event.key !== 'Tab') return;
        var items = focusable();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      function open() {
        if (isOpen) return;
        isOpen = true;
        lastFocus = document.activeElement;
        faq.setAttribute('data-lg-open', '');
        drawer.removeAttribute('inert');
        drawer.setAttribute('aria-hidden', 'false');
        tab.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('lg-scroll-lock');
        document.addEventListener('keydown', onKeydown);
        setTimeout(function () { (closeButton || drawer).focus(); }, 50);
      }

      function close() {
        if (!isOpen) return;
        isOpen = false;
        faq.removeAttribute('data-lg-open');
        drawer.setAttribute('inert', '');
        drawer.setAttribute('aria-hidden', 'true');
        tab.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('lg-scroll-lock');
        document.removeEventListener('keydown', onKeydown);
        if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
        else tab.focus();
      }

      tab.addEventListener('click', open);
      if (closeButton) closeButton.addEventListener('click', close);
      if (scrim) scrim.addEventListener('click', close);

      // One open at a time for browsers without <details name> support
      if (list) {
        list.addEventListener('toggle', function (event) {
          var item = event.target;
          if (!item.open) return;
          toArray(list.querySelectorAll('details[open]')).forEach(function (other) {
            if (other !== item) other.open = false;
          });
        }, true);
      }

      document.addEventListener('shopify:block:select', function (event) {
        var item = event.target && event.target.closest ? event.target.closest('details') : null;
        if (!item || !drawer.contains(item)) return;
        open();
        item.open = true;
      });

      faq.lgFaq = { open: open, close: close };
    }
  };

  /* ------------------------------------------------------------------------
     StickyAtc: visible after the hero CTA scrolls past, hidden near the final offer
     ------------------------------------------------------------------------ */
  var StickyAtc = {
    init: function (root) {
      var self = this;
      toArray(root.querySelectorAll('[data-lg-sticky]')).forEach(function (bar) {
        if (once(bar, 'StickyAtc')) self.setup(bar);
      });
    },

    setup: function (bar) {
      var hero = document.getElementById('lg-hero-cta');
      if (!hero || !('IntersectionObserver' in window)) return;

      var state = { heroAbove: false, finalCta: false, finalOffer: false };

      function render() {
        var show = state.heroAbove && !state.finalCta && !state.finalOffer;
        if (show) bar.setAttribute('data-lg-visible', '');
        else bar.removeAttribute('data-lg-visible');
      }

      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          state.heroAbove = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        });
        render();
      }, { threshold: 0 }).observe(hero);

      [['lg-final-cta', 'finalCta'], ['lg-final-offer', 'finalOffer']].forEach(function (pair) {
        var el = document.getElementById(pair[0]);
        if (!el) return;
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { state[pair[1]] = entry.isIntersecting; });
          render();
        }, { threshold: 0 }).observe(el);
      });
    }
  };

  /* ------------------------------------------------------------------------
     Public namespace
     ------------------------------------------------------------------------ */
  LG.MojoPDP = {
    Plans: Plans,
    Cart: Cart,
    Gallery: Gallery,
    AutoRail: AutoRail,
    Reveal: Reveal,
    Delivery: Delivery,
    Anchors: Anchors,
    Videos: Videos,
    Timeline: Timeline,
    DoseBars: DoseBars,
    Accordion: Accordion,
    ProofSlider: ProofSlider,
    CompareScrub: CompareScrub,
    FaqDrawer: FaqDrawer,
    StickyAtc: StickyAtc,

    modules: [
      'Plans', 'Cart', 'Gallery', 'AutoRail', 'Reveal', 'Delivery', 'Anchors',
      'Videos', 'Timeline', 'DoseBars', 'Accordion', 'ProofSlider', 'CompareScrub',
      'FaqDrawer', 'StickyAtc'
    ],

    init: function (root) {
      var scope = root && root.querySelectorAll ? root : document;
      var self = this;
      this.modules.forEach(function (name) {
        var module = self[name];
        if (module && typeof module.init === 'function') {
          try {
            module.init(scope);
          } catch (err) {
            if (window.console) console.error('LiquidGold.MojoPDP.' + name, err);
          }
        }
      });

      if (once(document.body, 'ScrollBuy')) {
        document.addEventListener('click', function (event) {
          var trigger = event.target.closest('[data-lg-scroll-buy]');
          if (!trigger) return;
          event.preventDefault();
          self.scrollToBuy(trigger.dataset.lgScrollBuy || PROMO_KEY);
        });
      }
    },

    // Scroll to the nearest plan selector and pre-select a plan.
    scrollToBuy: function (planKey) {
      var key = planKey || PROMO_KEY;
      var candidates = toArray(document.querySelectorAll('[data-lg-plan-selector]:not([data-lg-plan-selector="sticky"])'));
      var target = document.getElementById('lg-buybox');
      var best = Infinity;
      candidates.forEach(function (el) {
        var distance = Math.abs(el.getBoundingClientRect().top);
        if (distance < best) {
          best = distance;
          target = el;
        }
      });
      Plans.selectByKey(key);
      if (!target) return;
      var offset = isDesktop() ? 24 : 96;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: reducedMotion() ? 'auto' : 'smooth' });
    }
  };

  function boot() {
    LG.MojoPDP.init(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    LG.MojoPDP.init(event.target);
  });
})();
